import React, { useState } from 'react';
import Button from '../common/Button';
import { Modal, ModalContent } from '../common';
import { Heading, Text, Typography } from '../common/Typography';

const StartFreshWarningModal = ({ isOpen, onClose, onConfirm, guestName, clubName }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onConfirm();
    } catch (err) {
      console.error('Error starting fresh:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnBackdropClick={!loading}>
      <ModalContent size="small" className="overflow-y-auto">
        <Heading level={3} className="mb-4 text-danger">
          Start Fresh – This Cannot Be Undone
        </Heading>

        <div className="space-y-4 mb-6">
          <Text className="text-text-secondary">If you start fresh, the following will happen:</Text>

          <ul className="list-disc list-inside space-y-2 text-sm text-text-secondary ml-4">
            <li>
              The guest account <Typography variant="strong">{guestName || 'this guest'}</Typography> will be
              archived for {clubName || 'this club'}
            </li>
            <li>Your guest data (games, ELO ratings, partnerships) will no longer be mergeable</li>
            <li>You will begin a new club membership with no historical data</li>
            <li>This action is permanent and cannot be undone</li>
          </ul>

          <div className="bg-warning-light border border-warning/30 rounded-lg p-3">
            <Text className="text-sm text-warning-dark">
              <Typography variant="strong">Warning:</Typography> Starting fresh means you will lose access to all
              your previous game history, ELO ratings, and partnerships from this guest account.
            </Text>
          </div>
        </div>

        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:gap-3">
          <Button onClick={onClose} variant="outline" className="flex-1" disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="primary"
            className="flex-1 bg-danger hover:bg-danger-dark"
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Confirm Start Fresh'}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default StartFreshWarningModal;
